import Api from "@/api";
import TYPES from "./mutations_type";
// const fetch = Api.fetch

export default {};
